import Rest from '@services/Rest'

/**
 * @typedef {ChargebackService}
 */
export default class ChargebackService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/chargeback'
}
